import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import { IconSize } from '../IconWrap';
import s from './CircleWrap.scss';
const CircleWrap = (_param)=>{
    var { size = IconSize.MEDIUM, circleClassName, children } = _param, props = _object_without_properties(_param, [
        "size",
        "circleClassName",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['disc'], s[size], circleClassName)
    }, children);
};
CircleWrap.displayName = 'CircleWrap';
export default CircleWrap;

//# sourceMappingURL=CircleWrap.js.map